import type { EmblemRarity } from "@/lib/domain/EmblemRarity";

export const getColorForEmblemRarity = (rarity: EmblemRarity): string => {
	switch (rarity) {
	case "Rare":
		return "#124AED";
	case "Majestic":
		return "#ED2A12";
	case "Legendary":
		return "#DD9945";
	case "Fabled":
		return "#5AAA3E";
	default:
		return "#666666";
	}
};
